{
  "plan_details": {
    "frequency": {
      "annually": "Anualmente",
      "monthly": "Mensualmente",
      "title": "Paga anualmente y ahorra un 10%"
    },
    "choose_currency": "Elige tu moneda",
    "includes": "Qué incluye:",
    "everything_in": "Todo lo incluido en {{ plan }} además de:",
    "per_user": "por usuario/por mes",
    "switch_to": "Cambia a {{ plan }}",
    "upgrade_to": "Actualiza a {{ plan }}",
    "manage_plan": "Administra el plan",
    "call_us": "¡Llámenos",
    "contact_us": "Póngase en contacto con nosotros",
    "title": {
      "part_1": "Elige el plan perfecto para ti y tus",
      "part_2": "¿Equipo"
    },
    "subtitle": {
      "part_1": "Compara nuestros planes y funciones en nuestro",
      "part_2": "página de precios",
      "part_3": "o"
    },
    "plans": {
      "professional": {
        "name": "profesional",
        "prev_plan": "",
        "features": {
          "1": "Planes ilimitados para tu evento",
          "2": "Acceso a una amplia biblioteca de plantillas de capas",
          "3": "Modelos 3D para visualizar los planos con precisión",
          "4": "Atributos para capturar datos, incluidas fechas y costos",
          "5": "Espacio de trabajo compartido para tu equipo",
          "6": "Capas e íconos personalizables y flexibles",
          "7": "Herramientas de análisis que incluyen una calculadora de capacidad de multitudes",
          "8": "Exportaciones profesionales de PDF",
          "9": "Integración con CAD y actualizaciones ilimitadas",
          "10": "Soporte de incorporación",
          "11": "¡Espectadores ilimitados!"
        }
      },
      "premium": {
        "name": "premium",
        "prev_plan": "profesional",
        "features": {
          "1": "Capture y visualice los planes por fecha y hora",
          "2": "Herramientas de colaboración que incluyen comentarios, etiquetas e hilos",
          "3": "Combine planes de diferentes usuarios y equipos",
          "4": "Analice las cantidades y los costos de su proyecto",
          "5": "Exportación de datos geoespaciales en formatos SIG",
          "6": "Servicio de importación de CAD",
          "7": "Soporte de incorporación personalizado",
          "8": "¡Espectadores ilimitados!"
        }
      },
      "enterprise": {
        "name": "empresa",
        "prev_plan": "prima",
        "features": {
          "1": "Incorporación y gestión de cuentas a medida",
          "2": "Visualice los planes con gráficos con calidad de juego",
          "3": "Planifica con los mapas urbanos 3D de Google",
          "4": "Publica mapas de marca en línea",
          "5": "Soporte experto para crear modelos 3D, iconos y plantillas",
          "6": "SSO para mayor seguridad",
          "7": "Soporte ininterrumpido"
        }
      }
    }
  }
}